<template>
  <span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16px"
      style="margin-top:-.1rem"
      viewBox="0 -960 960 960"
      fill="currentColor"
    >
      <path
        d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-240v-32q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v32q0 33-23.5 56.5T720-160H240q-33 0-56.5-23.5T160-240Z"
      ></path>
    </svg>
    <b v-if="showAuthor">{{ authorName }}</b>
    <span v-if="showAuthor && (showCompany && author.company)"> {{ $t('reviews.from') }} </span>
    <b v-if="showCompany">{{ author.company }}</b>
    <span v-if="(showAuthor || showCompany) && (showCity && author.city)"> {{ $t('reviews.fromCity') }} </span>
    <b v-if="showCity">{{ author.city }}</b>
    <!-- <span v-if="((showCompany && author.company) || (showCity && author.company)) && showDate">,</span>
    <span v-if="(showAuthor || showCompany || showCity) && showDate"> am </span>
    <b v-if="showDate">{{formatDate(author.date)}}</b> -->
  </span>
</template>


<script>
export default {
  name: "Author",
  props: {
    author: Object,
    showAuthor: Boolean,
    showCompany: Boolean,
    showCity: Boolean,
    showDate: Boolean
  },
  computed: {
    authorName: function () {
      return this.author.name ? this.author.name : 'Anonym';
    }
  }
}
</script>
